import * as React from 'react';
import type { SVGProps } from 'react';
const SvgXSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      d="M0.75 0.75 9.25 9.25M9.25 0.75 0.75 9.25"
    />
  </svg>
);
export default SvgXSmall;
